import styled from "styled-components";

export const LegalMainDiv = styled.div`
  position: relative;
  background-color: black;
  color: white;
  min-height: 100vh;
`;

export const LegalHeroSection = styled.div`
  text-align: center;
  padding: 150px 20px 60px;
  max-width: 1200px;
  margin: 0 auto;
  
  h1 {
    font-size: 56px;
    font-weight: 700;
    margin-bottom: 24px;
    background: linear-gradient(180deg, #FFFFFF 0%, #A1A1A1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    
    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    font-size: 18px;
    color: #A1A1A1;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const LegalContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px 100px;

  h2 {
    font-size: 32px;
    font-weight: 600;
    margin: 40px 0 20px;
    color: white;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    margin: 30px 0 15px;
    color: #E0E0E0;
  }

  p {
    font-size: 16px;
    line-height: 1.8;
    color: #C0C0C0;
    margin-bottom: 20px;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-bottom: 20px;
    color: #C0C0C0;

    li {
      margin-bottom: 10px;
      line-height: 1.6;
    }
  }

  a {
    color: white;
    text-decoration: underline;
    
    &:hover {
      color: #A1A1A1;
    }
  }
`;
